import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { magazinesAPI } from '../utils/api';

export const useFirstTimeUser = () => {
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useSelector(state => state.auth);

  useEffect(() => {
    const checkFirstTimeUser = async () => {
      if (!user) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);

        // Check if user has dismissed welcome modal
        if (user.welcomeModalDismissed) {
          setIsFirstTime(false);
          setIsLoading(false);
          return;
        }

        // Check if user has any magazines configured
        const response = await magazinesAPI.getAll();
        const magazines = response.data;

        // User is first-time if they have no magazines
        setIsFirstTime(!magazines || magazines.length === 0);
      } catch (error) {
        console.error('Error checking first-time user status:', error);
        // If there's an error, assume they're not first-time to avoid showing modal unnecessarily
        setIsFirstTime(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkFirstTimeUser();
  }, [user]);

  return { isFirstTime, isLoading };
};
